<template>
  <div>
    <!-- A refused or failed pick. Drawn as text runs, never v-html: the hint comes from the
         server. A phone number is one run kept on one line. -->
    <v-alert v-if="message" :type="messageType" variant="tonal" density="compact" class="mb-4 text-body-2"
      closable data-test="company-choice-message" @click:close="emit('clearMessage')">
      <template v-for="(part, partIndex) in messageParts" :key="partIndex"><span v-if="part.keep"
          class="company-choice-nowrap">{{ part.text }}</span><template v-else>{{ part.text }}</template></template>
    </v-alert>

    <v-list bg-color="transparent">
      <v-list-item v-for="row in rows" :key="row.id" :disabled="!!busyId"
        class="company-row border rounded mb-2 py-2" :data-test="'company-choice-' + row.status" @click="emit('select', row)">
        <!-- The name, with its state directly under it on the left, sized to its text. -->
        <v-list-item-title class="company-row-name">{{ row.name }}</v-list-item-title>
        <div class="company-row-state mt-1">
          <v-chip size="small" variant="tonal" :color="chipColour(row.status)" label>
            {{ $t(labelKey(row.status)) }}
          </v-chip>
        </div>
        <template v-slot:append>
          <v-btn color="success" variant="flat" size="small" class="ml-3" :loading="busyId === row.id"
            @click.stop="emit('select', row)">
            {{ $t('company_select_select_button') }}
          </v-btn>
        </template>
      </v-list-item>
    </v-list>
  </div>
</template>

<script setup>
import { computed } from 'vue';

import CompanyChoices from './CompanyChoices.js';
import PasswordRecoveryReply from './PasswordRecoveryReply.js';

const props = defineProps({
  rows: { type: Array, default: () => [] },
  busyId: { type: String, default: null },
  message: { type: String, default: '' },
  messageType: { type: String, default: 'warning' },
});

const emit = defineEmits(['select', 'clearMessage']);

const messageParts = computed(() => PasswordRecoveryReply.messageParts(props.message));

const labelKey = (status) => CompanyChoices.LabelKeys[status] || CompanyChoices.LabelKeys.active;

const chipColour = (status) => {
  if (status === CompanyChoices.Status.CONTACT_SUPPORT) return 'warning';
  if (status === CompanyChoices.Status.INACTIVE) return 'grey';
  return 'success';
};
</script>

<style scoped>
/* Long company names wrap rather than end in an ellipsis, so two companies that share
   a long prefix can still be told apart. */
.company-row :deep(.v-list-item-title) {
  white-space: normal;
  overflow-wrap: anywhere;
}

/* The chip keeps its own width instead of stretching across the row. */
.company-row-state {
  display: flex;
  justify-content: flex-start;
}

.company-choice-nowrap {
  white-space: nowrap;
}
</style>
